var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.756,
    height: 15.756,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7709"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6717",
    d: "M.716 10.026a.716.716 0 00-.716.716v2.149a2.865 2.865 0 002.865 2.865h10.026a2.865 2.865 0 002.865-2.865v-2.149a.716.716 0 00-1.432 0v2.149a1.432 1.432 0 01-1.433 1.435H2.865a1.432 1.432 0 01-1.432-1.432v-2.152a.716.716 0 00-.717-.716z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6718",
    d: "M7.878 0a.716.716 0 00-.716.716v8.952L5.508 8.089A.716.716 0 104.52 9.12l2.865 2.743a.716.716 0 00.988 0l2.865-2.743a.716.716 0 10-.988-1.031L8.596 9.668V.716A.716.716 0 007.878 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.ff3b23972d46bcf94f598d13f078e60d.svg";
export { ForwardRef as ReactComponent };